export default __webpack_public_path__ + "static/media/shark-label-4.367d0b0e.gif";